var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "43px",
    height: "43px",
    viewBox: "0 0 240 266",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M48.4,237.4C27.2,237.4,10,220.2,10,199V57c0-21.2,17.2-38.4,38.4-38.4h36.5c6.3,0,11.5,5.1,11.5,11.5l0,0c0,6.4-5.1,11.5-11.5,11.5H50.3C41.3,44.2,35.6,50,33,59v138.2c2.6,9,8.3,14.7,17.3,17.3h138.2c9-2.6,14.7-8.3,17.3-17.3v-40.3c0-6.4,5.1-11.5,11.5-11.5l0,0c6.4,0,11.5,5.2,11.5,11.5V199c0,21.2-17.2,38.4-38.4,38.4H48.4z M182.7,122.2c-2.4,0-4.3-0.5-5.8,0c-4.7-3.6-7.4-8-5.8-11.5V99.2c-42.1-2.9-88.9,37.4-99.9,74.8c-2.4-8.2-3.8-16.9-3.8-25.9c0-50.1,52.7-103.6,103.6-106.5V30.1c-1.6-3.5,1.1-7.9,5.8-11.5c1.4,0.5,3.4,0,5.8,0c2.3,0,5,0.9,5.8,0L240.9,60c3.2,2.4,5.1,6.3,5.1,10.4s-1.9,7.9-5.1,10.4l-52.4,41.5C187.7,121.3,185,122.2,182.7,122.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.fdc26c58861639c211afb1f46f1a57f4.svg";
export { ForwardRef as ReactComponent };